import { render, staticRenderFns } from "./MonthlyUpdateScore.vue?vue&type=template&id=54ff204f&"
import script from "./MonthlyUpdateScore.vue?vue&type=script&lang=js&"
export * from "./MonthlyUpdateScore.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyUpdateScore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports